import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getPrefixedLogger, prefixes } from '@ringcentral/rwc-utils/src/rwc-logger';
import { loginAsGuest } from '@low/utils/auth';
import { AuthStatus } from '@low/types';

const logger = getPrefixedLogger(prefixes.VC_CONTAINERS, 'session-manager');

class BasicSessionManager extends PureComponent {
    componentDidMount() {
        this.updateLoginStatus();
    }

    async updateLoginStatus() {
        const { sdk, setAuthStatus } = this.props;
        setAuthStatus(AuthStatus.PENDING);
        const auth = sdk().platform().auth();
        const authData = await auth.data();

        const isStuckWithoutToken =
            authData && authData.owner_id && authData.refresh_token && !authData.access_token;

        const weHaveAccessToken = authData && authData.access_token;

        if (isStuckWithoutToken) {
            logger.info('updateLoginStatus: stuck without token', authData);

            await sdk().platform().refresh();
            await this.updateLoginStatus();
        } else if (weHaveAccessToken) {
            logger.info('updateLoginStatus: provide access token');
            setAuthStatus(AuthStatus.SUCCESS);
        } else {
            logger.info('updateLoginStatus: login as guest');
            try {
                await loginAsGuest(sdk);
                setAuthStatus(AuthStatus.SUCCESS);
            } catch (e) {
                logger.error('login as guest failed', e);
                setAuthStatus(AuthStatus.FAILED);
            }
        }
    }

    render() {
        return null;
    }
}

BasicSessionManager.propTypes = {
    sdk: PropTypes.func,
    setAuthStatus: PropTypes.func,
};

export default BasicSessionManager;
